import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  Button,
  Stack,
  Tabs,
  Tab,
  Card,
  Container,
  Row,
  Col,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImage } from "@fortawesome/free-solid-svg-icons";

// 处理文本中的URL并转换为超链接
const convertTextToLinks = (text) => {
  if (!text) return "";
  // 匹配URL的正则表达式
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  // 将URL替换为<a>标签
  return text.replace(urlRegex, (url) => {
    return `<a href="${url}" target="_blank" rel="noopener noreferrer" class="text-primary">${url}</a>`;
  });
};

const ArticleItem = ({ article }) => {
  const processedDesc = convertTextToLinks(article.desc);

  return (
    <Card className="mb-3 shadow-sm border-0">
      <Card.Body>
        <Card.Title className="mb-2">
          <a
            href={article.link}
            target="_blank"
            rel="noopener noreferrer"
            className="text-dark text-decoration-none hover:text-primary"
          >
            {article.name}
          </a>
        </Card.Title>
        <Card.Text
          className="text-muted small"
          dangerouslySetInnerHTML={{ __html: processedDesc }}
        />
      </Card.Body>
    </Card>
  );
};
const JournalPage = () => {
  const { journalId } = useParams();
  const [journal, setJournal] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetch("/json/journals.json")
      .then((response) => response.json())
      .then((data) => {
        const foundJournal = data.journals.find(
          (item) => item.id === journalId
        );
        setJournal(foundJournal || null);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error loading journals.json:", error);
        setLoading(false);
      });
  }, [journalId]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-50">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!journal) {
    return (
      <div className="text-center py-12">
        <h3 className="text-muted mb-4">Journal data not found</h3>
        <Button variant="primary" href="/">
          Back Home
        </Button>
      </div>
    );
  }

  // 处理描述文本，转换URL为链接
  const processedDescription = convertTextToLinks(journal.desc);

  return (
    <Container className="journal-detail">
      {/* Journal Header Card */}
      <Card className="mb-6 shadow-sm border-0">
        <Card.Body>
          <Row className="align-items-start">
            {/* Journal Image */}
            <Col md={3} className="mb-4 mb-md-0">
              <div className="rounded overflow-hidden shadow-sm bg-light d-flex justify-center">
                {journal.img ? (
                  <img
                    alt={journal.title}
                    src={journal.img}
                    //   className="w-100 h-auto object-cover"
                    style={{ maxHeight: "330px" }}
                  />
                ) : (
                  <div
                    style={{
                      padding: "100px 0",
                      height: "330px",
                      textAlign: "center",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faImage}
                      size="3x"
                      className="image-icon"
                      style={{ color: "gray" }}
                    />
                    <div>{journal.title}</div>
                  </div>
                )}
              </div>

              <div className="d-grid gap-2 mt-4">
                {Boolean(journal.submit_url) ? (
                  <Button
                    variant="primary"
                    size="lg"
                    className="shadow-sm"
                    href={journal.submit_url}
                    target="_blank"
                  >
                    Submit Manuscript
                  </Button>
                ) : (
                  // 不存在时：不可点击（disabled）、无跳转属性、视觉上区分（可选改variant）
                  <Button
                    variant="secondary" // 可选：用次要样式区分“不可点击”状态
                    size="lg"
                    className="shadow-sm opacity-75" // 可选：加透明度增强不可点击视觉提示
                    disabled // 关键属性：禁用按钮，使其不可点击
                  >
                    Submit Manuscript
                  </Button>
                )}
                {Boolean(journal.keai_url) ? (
                  <Button
                    variant="primary"
                    size="lg"
                    className="shadow-sm"
                    target="_blank"
                    href={journal.keai_url}
                  >
                    Author Guidelines
                  </Button>
                ) : (
                  <Button
                    variant="primary"
                    size="lg"
                    className="shadow-sm"
                    href="/guide"
                  >
                    Author Guidelines
                  </Button>
                )}

                {Boolean(journal.edit_url) ? (
                  <Button
                    variant="primary"
                    size="lg"
                    className="shadow-sm"
                    target="_blank"
                    href={journal.edit_url}
                  >
                    Editorial Board
                  </Button>
                ) : (
                  <Button
                    variant="secondary"
                    size="lg"
                    className="shadow-sm opacity-75"
                    disabled
                  >
                    Editorial Board
                  </Button>
                )}

                {journal.id === "cpa" ? (
                  <a href={`/young_editorial/#${journal.id}`}>
                    <Button
                      variant="primary"
                      size="lg"
                      className="shadow-sm"
                      style={{ width: "100%" }}
                    >
                      Young Editorial Board Member
                    </Button>
                  </a>
                ) : (
                  <Button
                    variant="secondary"
                    size="lg"
                    className="shadow-sm opacity-75"
                    style={{ width: "100%" }}
                    disabled
                  >
                    Young Editorial Board Member
                  </Button>
                )}
              </div>
            </Col>

            {/* Journal Information */}
            <Col md={9}>
              <div className="mb-4">
                <h1 className="mb-3">{journal.title}</h1>
                {journal.issn  && (
                  <Stack
                    direction="horizontal"
                    gap={4}
                    className="mb-4 text-muted"
                  >
                    <span>ISSN: {journal.issn}</span>
                    {
                      journal.impact && (<>
                    <div className="vr" />
                    <span>
                      Impact Factor:{" "}
                      <strong className="text-dark">{journal.impact}</strong>
                    </span>
                      </>)
                    }
                  </Stack>
                )}
              </div>

              <div className="mb-4">
                <h3 className="h5 mb-3 text-secondary">About This Journal</h3>
                <div>
                  <div
                    className="text-muted"
                    dangerouslySetInnerHTML={{ __html: processedDescription }}
                  />
                  <div className="text-muted">
                    <div className="mt-2">
                      {journal.section && (
                        <div className="mt-2 mb-2">
                          This journal contains four sections:
                        </div>
                      )}
                      {(isExpanded
                        ? Object.entries(journal.section)
                        : Object.entries(journal.section).slice(0, 1)
                      ).map(([key, value]) => (
                        <div key={key} className="mb-2">
                          {value}
                        </div>
                      ))}

                      {/* 只在条目数量超过3时显示切换按钮 */}
                      {Object.entries(journal.section).length > 3 && (
                        <button
                          className="btn btn-link text-muted p-0"
                          onClick={() => setIsExpanded(!isExpanded)}
                          aria-expanded={isExpanded}
                        >
                          {isExpanded ? "Hide" : "Show More"}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="mb-4">
                {journal.editor_in_chief && (
                  <h3 className="h5 mb-3 text-secondary">Editor-in-Chief</h3>
                )}
                <div className="text-muted">{journal.editor_in_chief}</div>
              </div>
              <div className="text-muted">{journal.explain}</div>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      {/* Content Tabs */}
      <Tabs defaultActiveKey="articles" transition={false} className="mb-6">
        {/* 最新文章 Tab - 对应 recent 数据 */}
        <Tab eventKey="articles" title="Recent Articles" className="pt-4">
          {journal.recent && journal.recent.length > 0 ? (
            <div>
              {journal.recent.map((article, index) => (
                <ArticleItem key={index} article={article} />
              ))}
            </div>
          ) : (
            <div className="d-flex justify-content-center py-8 text-muted">
              <p>No recent articles available.</p>
            </div>
          )}
        </Tab>

        {/* 最多下载文章 Tab - 对应 most_downloaded 数据 */}
        <Tab
          eventKey="downloaded"
          title="Most Downloaded Articles"
          className="pt-4"
        >
          {journal.most_downloaded && journal.most_downloaded.length > 0 ? (
            <div>
              {journal.most_downloaded.map((article, index) => (
                <ArticleItem key={index} article={article} />
              ))}
            </div>
          ) : (
            <div className="d-flex justify-content-center py-8 text-muted">
              <p>No most downloaded articles available.</p>
            </div>
          )}
        </Tab>

        {/* 最多引用文章 Tab - 对应 most_cited 数据 */}
        <Tab
          eventKey="cited" // 修正eventKey与内容匹配
          title="Most Cited Articles"
          className="pt-4"
        >
          {journal.most_cited && journal.most_cited.length > 0 ? (
            <div>
              {journal.most_cited.map((article, index) => (
                <ArticleItem key={index} article={article} />
              ))}
            </div>
          ) : (
            <div className="d-flex justify-content-center py-8 text-muted">
              <p>No most cited articles available.</p>
            </div>
          )}
        </Tab>
      </Tabs>
    </Container>
  );
};

export default JournalPage;
